export default __webpack_public_path__ + "static/media/Great.7d686888.mp3";